import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {CompleterService, CompleterData, CompleterItem } from 'ng2-completer';
import {User} from '../../user';
import {ProfileService} from '../profile.service';
import { CITIES } from '../../../constants/cities';

@Component({
    selector: 'main-profile-edit',
    template: require('./profile-edit.component.html'),    
    providers: [CompleterService, ProfileService]
})

export class MainProfileEditComponent implements OnInit {
    
    @Input('profile-obj') user: User;
    @Input('isNameWrong') isNameWrong: boolean;
    @Input('isNifWrong') isNifWrong: boolean;
    @Input('isPhoneWrong') isPhoneWrong: boolean;
    @Input('isCityWrong') isCityWrong: boolean;
    @Input('isAddressWrong') isAddressWrong: boolean;
    @Input('isZipWrong') isZipWrong: boolean;

    @Output('submit-profile') submitProfile = new EventEmitter();
    @Output('nameWrong') nameWrong = new EventEmitter();
    @Output('nifWrong') nifWrong = new EventEmitter();
    @Output('phoneWrong') phoneWrong = new EventEmitter();
    @Output('cityWrong') cityWrong = new EventEmitter();
    @Output('addressWrong') addressWrong = new EventEmitter();
    @Output('zipWrong') zipWrong = new EventEmitter();

    private dataService: CompleterData;
    private previousUser: User;

    constructor(
        private _profileService: ProfileService,
        _completerService: CompleterService
    ) {
        this.dataService = _completerService.local(CITIES, 'name', 'name');
    }

    ngOnInit() {        
        this.copyUser(this.user);
    }

    ngDoCheck() {        

        if (!this.userEquals(this.user, this.previousUser)) {
            // inputSettings changed
            // some logic here to react to the change
            this.copyUser(this.user);
            this.submitProfile.emit({
                value: this.user
            })
        }

        this.nameWrong.emit({
            value: this.user.name
        })

        this.nifWrong.emit({
            value: this.user.nif
        })

        this.phoneWrong.emit({
            value: this.user.phone
        })

        this.cityWrong.emit({
            value: this.user.city_name
        })

        this.addressWrong.emit({
            value: this.user.address
        })

        this.zipWrong.emit({
            value: this.user.zip
        })

    }

    goBack() {
        window.history.back();
    }

    public onCitySelected(selected: CompleterItem) {

    }

    private copyUser(user: User) {
        this.previousUser = Object.assign({}, this.user);
        /* this.previousUser.id = user.id;
         this.previousUser.name = user.name;
         this.previousUser.nif = user.nif;
         this.previousUser.phone = user.phone;*/
    }

    private userEquals(user1: User, user2: User) {
        return user1.email == user2.email &&
            user1.name == user2.name &&
            user1.nif == user2.nif &&
            user1.phone == user2.phone;
    }
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/main/profile/profile_edit/profile-edit.component.ts
 **/